import { Component, OnInit } from '@angular/core';
import { LanguageService } from '@services/layout/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styles: []
})
export class AppComponent implements OnInit  {
  constructor(public languageService: LanguageService) {}
  ngOnInit() {
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  }
}
